export default __webpack_public_path__ + "static/media/CD__0003_0001.9a4180d7.png";